import React from 'react';
import { Box } from '@mui/material';
import styled from 'styled-components/macro';
import DashboardLayout from './Layout';
import { connect } from 'react-redux';
import cs from 'classnames';
import CircularProgress from '@mui/material/CircularProgress';
/* const HeadDiv = styled.div`
	display: flex;
	align-items: center;
	height: 50px;
	border-bottom: 1px solid rgba(34, 36, 38, 0.1);
	padding: 12px;
	flex: 0 0 auto;
	.header {
		margin-bottom: 0 !important;
	}

	@media screen and (max-width: 770px) {
		height: 100px !important;
		overflow-x: auto;
		overflow-y: hidden;
		max-width: 100%;
		display: block;
	}
`; */

const Page = (props) => {
	let { head, icon, title, subtitle, disabled } = props;
	//const [isSidebarOpen, setSidebarOpen] = useState(false);
	let user = { email: props.user.email, name: props.user.name };
	let agent = props && props.product && props.product.settings && props.product.settings.agent_limit;
	let instagram = props && props.product && props.product.settings && props.product.settings.instagram_limit;

	return (
		<>
			{/* <DashboardNavbar
				header={
					props.header || (
						<CardHeader as="h3">
							{props.icon && <p>asd</p>}
							<CardHeader.Content>{props.title}</CardHeader.Content>
							<CardHeader.Subheader>{props.subtitle || ''}</CardHeader.Subheader>
						</CardHeader>
					)
				}
				onSidebarOpen={() => setSidebarOpen(true)}
			/> */}
			<DashboardLayout
				instagram={instagram}
				user={user}
				isAgent={agent}
				head={head}
				icon={icon}
				className="layout"
				title={title}
				subtitle={subtitle}
				disabled={disabled}
			>
				<div className={cs('layout-body', { 'd-flex': props.hasOwnProperty('flex') })}>{props.children}</div>
			</DashboardLayout>
		</>
	);
};

Page.Loader = (props) => (
	<Box sx={{ position: 'absolute', top: '50%', left: '50%' }}>
		<CircularProgress />
	</Box>
);

Page.Wrap = styled.div`
	padding: 20px;
`;

const stateToProps = (state) => ({
	access: state.access,
	location: state.router.location,
	product: state.product.maytapi,
	user: state.access.user.loggedUserObj,
});
export default connect(stateToProps)(Page);
